import axios from 'axios'
import security from '@/services/security.js'

export default {
  getBudgetWithActuals (courseKey) {
    const config = { headers: security.getAuthHeader() }
    return axios.get('/finance/budget/' + courseKey + '/actuals', config)
      .then(response => {
        return response.data
      })
  },
  getBudgetCategoryWithDetails (courseKey) {
    const config = { headers: security.getAuthHeader() }
    return axios.get('/finance/budget/' + courseKey + '/categories', config)
      .then(response => {
        return response.data
      })
  },
  updateBudget (budget) {
    const config = { headers: security.getAuthHeader() }
    return axios.put('/finance/budget', budget, config)
      .then(response => {
        return response.data
      })
  },
  updateBudgetItem (budgetItem, courseKey) {
    const config = { headers: security.getAuthHeader() }
    return axios.put('/finance/budget/' + courseKey + '/item', budgetItem, config)
      .then(response => {
        return response.data
      })
  },
  getIncomeBudgetItems (courseKey) {
    const config = { headers: security.getAuthHeader() }
    return axios.get('/finance/budget/' + courseKey + '/item/stub/income', config)
      .then(response => {
        return response.data
      })
  },
  getExpenseBudgetItems (courseKey) {
    const config = { headers: security.getAuthHeader() }
    return axios.get('/finance/budget/' + courseKey + '/item/stub/expense', config)
      .then(response => {
        return response.data
      })
  }
}
